/**
 * Use this plugin if you want to send an event to a different tab
 * @see https://www.npmjs.com/package/vue-tabevents
 */
import Vue from 'vue'
import vueTabevents from 'vue-tabevents'

Vue.use(vueTabevents)
